/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLeagueScheduleResponse
 */
export interface GetLeagueScheduleResponse {
    /**
     * 
     * @type {string}
     * @memberof GetLeagueScheduleResponse
     */
    leagueId: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetLeagueScheduleResponse
     */
    matchdays: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetLeagueScheduleResponse
     */
    currentMatchday?: number;
}

/**
 * Check if a given object implements the GetLeagueScheduleResponse interface.
 */
export function instanceOfGetLeagueScheduleResponse(value: object): value is GetLeagueScheduleResponse {
    if (!('leagueId' in value) || value['leagueId'] === undefined) return false;
    if (!('matchdays' in value) || value['matchdays'] === undefined) return false;
    return true;
}

export function GetLeagueScheduleResponseFromJSON(json: any): GetLeagueScheduleResponse {
    return GetLeagueScheduleResponseFromJSONTyped(json, false);
}

export function GetLeagueScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeagueScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'leagueId': json['leagueId'],
        'matchdays': json['matchdays'],
        'currentMatchday': json['currentMatchday'] == null ? undefined : json['currentMatchday'],
    };
}

export function GetLeagueScheduleResponseToJSON(json: any): GetLeagueScheduleResponse {
    return GetLeagueScheduleResponseToJSONTyped(json, false);
}

export function GetLeagueScheduleResponseToJSONTyped(value?: GetLeagueScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leagueId': value['leagueId'],
        'matchdays': value['matchdays'],
        'currentMatchday': value['currentMatchday'],
    };
}

